/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useStoreLocator } from '@/data/Content/StoreLocator';
import { ContentContext } from '@/data/context/content';
import { StoreDetails } from '@/data/types/Store';
import { Marker } from '@react-google-maps/api';
import { FC, useContext } from 'react';

type StoreLocatorMarkerProps = {
	store: StoreDetails;
	index: number;
};

export const StoreLocatorMarker: FC<StoreLocatorMarkerProps> = (props) => {
	const { store, index } = props;
	const { onMarkerClick, clickedIndex } = useContext(ContentContext) as ReturnType<
		typeof useStoreLocator
	>;

	const markerIcon =
		clickedIndex === index ? '/images/pinSelectDPBlack.svg' : '/images/pinDPBlack.svg';

	return (
		<Marker
			icon={{ url: markerIcon }}
			position={store.coordinates}
			onClick={(e) => onMarkerClick(e, index)}
		/>
	);
};
